module.exports = __webpack_public_path__ + "img/sv67.8e98ca03.svg";